import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locale/en";
import vi from "./locale/vi";

const LANGUAGE_STORAGE_KEY = 'ff-language';

const getDefaultLanguage = (): string => {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'vi';
  } catch {
    return 'vi';
  }
};

const resources = {
  vi: vi,
  en: en,
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getDefaultLanguage(),
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export { LANGUAGE_STORAGE_KEY, getDefaultLanguage };
export default i18n;
